import React from 'react'

const Skills = () => {
    return (
        <skills className='center'>
            <section className="skills" id="skills">
                <div className="max-width">
                    <h2 className="title">My Expertise</h2>
                    <div className="skills-content">
                        <div className="column left">
                            <div className="text">My Skills from years of Experience</div>
                            <p>I am Skilled in Ayurvedic Management of Allergic Rhinitis, Sciatica, Jaundice, 
                                Post Covid Management, Prostrate Enlargement and Rheumatoid Arthritis. 
                    <br />
                    I also treat patients with Integrated medicine for Common cold, Fever, Loose Motions, Pain in Abdomen, etc.
                    </p>
                            </div>
                        <div className="column right">
                            <div className="bars">
                                <div className="info">
                                    <span>Allergic Rhinitis</span>
                                    <span>80%</span>
                                </div>
                                <div className="line rhinitis"></div>
                            </div>
                            <div className="bars">
                                <div className="info">
                                    <span>Sciatica</span>
                                    <span>75%</span>
                                </div>
                                <div className="line sciatica"></div>
                            </div>
                            <div className="bars">
                                <div className="info">
                                <span>Post Covid Complication</span>
                                    <span>70%</span>
                                </div>
                                <div className="line covid"></div>
                            </div>
                            <div className="bars">
                                <div className="info">
                                <span>Jaundice</span>
                                    <span>75%</span>
                                </div>
                                <div className="line jaundice"></div>
                            </div>
                            <div className="bars">
                                <div className="info">
                                    <span>Prostrate Enlargement (BPH)</span>
                                    <span>70%</span>
                                </div>
                                <div className="line prostrate"></div>
                            </div>
                            
                            <div className="bars">
                                <div className="info">
                                    <span>Rheumatoid Arthritis</span>
                                    <span>70%</span>
                                </div>
                                <div className="line arthritis"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </skills>
    )
}

export default Skills